export interface DistrictAddress {
  street: string
  city: string
  state: string
  zip: string
}

export interface DistrictRepresentative {
  name?: string | null
  party?: string | null
  district?: string | null
  email?: string | null
  website?: string | null
}

export interface SenatorInstance {
  id: string
  ilSenateDistrict: number
  senatorName: string
  brandLogoUrl?: string | null
  active?: boolean | null
}

// Persisted while the visitor is on the sign-in page so they don't have to
// re-enter their address on every visit. Storing the senator info inline
// means we can re-render the branded card on reload without doing another
// Census+Open States lookup. Only the district number is needed post-login
// to drive the navbar logo override (see useSenatorBrandedLogo).
export interface PersistedDistrictSession {
  address: DistrictAddress
  ilSenateDistrict: number
  ilSenator: DistrictRepresentative
  senatorInstanceId?: string | null
}

export const DISTRICT_SESSION_KEY = 'district-signin'

// Best-effort browser session id used to de-duplicate DistrictLookups audit rows.
export const DISTRICT_SESSION_ID_KEY = 'district-signin-session-id'

// Survives the auth redirect — read by the post-login navbar to look up the
// senator's brand logo and overlay it on top of the default BSO logo.
export const DISTRICT_LOGO_KEY = 'district-signin-il-senate-district'
